import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../app.state';
import { map } from 'rxjs/operators';
import { selectCalculations } from '../../calculation.state';
import { NavigationButton, NavigationDirection, navigationTree } from './step-navigation.constants';
import { CoreComponent } from '../../../core.component';
import { CalculationTypeEnum } from '../../../../api/models/calculation-type-enum';

@Component({
  selector: 'step-navigation',
  templateUrl: './step-navigation.component.html',
  styleUrls: ['./step-navigation.component.scss'],
})
export class StepNavigationComponent extends CoreComponent implements OnInit, OnDestroy {
  private roofType!: CalculationTypeEnum;
  private step!: number;
  buttons: NavigationButton[] = [];
  @Input()
  disabled = false;
  @Input()
  nextButtonLabel: null | string = null;
  @Output()
  forwardClickEmitter = new EventEmitter<boolean>();

  constructor(private readonly store: Store<AppState>) {
    super();
  }

  async ngOnInit(): Promise<void> {
    this.garbageCollector.push(
      this.store.pipe(map((state) => selectCalculations(state))).subscribe(async (calculations) => {
        if (this.roofType === calculations.activeTab && this.step === calculations.stepperStep) {
          return;
        }
        this.roofType = calculations.activeTab;
        this.step = calculations.stepperStep;
        if (this.step === 1) {
          this.buttons = [this.getButton(1, NavigationDirection.Forward)];
        } else if (!navigationTree[this.roofType][this.step]) {
          this.buttons = [this.getButton(this.step - 2, NavigationDirection.Back)];
        } else {
          this.buttons = [
            this.getButton(this.step - 2, NavigationDirection.Back),
            this.getButton(this.step, NavigationDirection.Forward),
          ];
        }
      }),
    );
  }

  getButton(index: number, direction: NavigationDirection): NavigationButton {
    return {
      ...navigationTree[this.roofType][index],
      direction,
      gaEvent:
        navigationTree[this.roofType][this.step - 1].gaEvent + '_to_' + navigationTree[this.roofType][index].gaEvent,
    };
  }

  isLastStep() {
    return navigationTree[this.roofType].length === this.step;
  }
}
